import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import {
  AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell, Legend
} from "recharts";

const COLORS = ["#C5A880", "#1A1A1A", "#6B5634", "#E5DAC8", "#4A6741", "#8C3A3A"];

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/dashboard").then(r => setD(r.data)); }, []);
  if (!d) return <Layout title="Analytics"><div>Loading…</div></Layout>;

  return (
    <Layout title="Analytics" subtitle="Performance">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="card-sharp p-6">
          <div className="label-tiny">Activity</div>
          <div className="text-xl font-light mt-1 mb-4" style={{fontFamily:"Outfit"}}>Signups vs Bills (14d)</div>
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={d.trend}>
              <CartesianGrid stroke="#F0EEE9" />
              <XAxis dataKey="day" stroke="#8C8C8C" fontSize={11} />
              <YAxis stroke="#8C8C8C" fontSize={11} />
              <Tooltip contentStyle={{background:"#1A1A1A", border:"none", color:"#fff"}} />
              <Area type="monotone" dataKey="signups" stroke="#C5A880" fill="#E5DAC8" />
              <Area type="monotone" dataKey="bills" stroke="#1A1A1A" fill="#1A1A1A" fillOpacity={0.1} />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="card-sharp p-6">
          <div className="label-tiny">Top Brands</div>
          <div className="text-xl font-light mt-1 mb-4" style={{fontFamily:"Outfit"}}>Claim distribution</div>
          {d.top_brands.length === 0 ? <div className="text-[#8C8C8C] text-sm">No claims yet.</div> : (
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={d.top_brands} dataKey="claims" nameKey="brand" outerRadius={100} label>
                  {d.top_brands.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Legend />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>

        <div className="card-sharp p-6 lg:col-span-2">
          <div className="label-tiny">Bills</div>
          <div className="text-xl font-light mt-1 mb-4" style={{fontFamily:"Outfit"}}>Daily uploads</div>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={d.trend}>
              <CartesianGrid stroke="#F0EEE9" />
              <XAxis dataKey="day" stroke="#8C8C8C" fontSize={11} />
              <YAxis stroke="#8C8C8C" fontSize={11} />
              <Tooltip contentStyle={{background:"#1A1A1A", border:"none", color:"#fff"}} />
              <Bar dataKey="bills" fill="#C5A880" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Layout>
  );
}
